import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of, EMPTY } from 'rxjs';
import { RouteReplayDataService } from '../services/route-replay-data.service';

export const routeReplayResolver: ResolveFn<boolean> = (route) => {

  const router = inject(Router);
  const dataService = inject(RouteReplayDataService);
  
  // Get routeIds from query parameter (comma-separated)
  const routeIdsParam = route.queryParams['routeIds'];
  const source = route.queryParams['source'];
  const buid = route.queryParams['buid'];

  if (!routeIdsParam) {
    router.navigate(['/error']);   
    return EMPTY;              
  }

  // Store comma-separated route IDs
  dataService.selectedRouteId.set(routeIdsParam);
  dataService.updateBuid(buid, source);

  return of(true);
};